// extracted by mini-css-extract-plugin
var _1 = "ggSniVO8J14Hca4aOC6H";
var _2 = "L92XSlU3ZLWyeHjjkZrB";
export { _1 as "interface", _2 as "loader" }
